import React from 'react';

export const reportColumns = [
  {
    title: 'ردیف',
    isRowNumber: true,
  },
  {
    title: 'نام کافه',
    dataIndex: 'cafeName',
    name: 'cafeName',
    isSortable: true,
  },
  {
    title: 'مجموع پیش پرداخت',
    dataIndex: 'sumCafeBasePrice',
    name: 'sumCafeBasePrice',
    isSortable: true,
    render: (sumCafeBasePrice) => <div>{Number(sumCafeBasePrice).toLocaleString()}</div>,
  },
  {
    title: 'مجموع ورودی ',
    dataIndex: 'sumTotalEntranceAmount',
    name: 'sumTotalEntranceAmount',
    isSortable: true,
    render: (sumTotalEntranceAmount) => <div>{Number(sumTotalEntranceAmount).toLocaleString()}</div>,
  },
  {
    title: 'مجموع پیش پرداخت + ورودی ',
    dataIndex: 'sumCafePrices',
    name: 'sumCafePrices',
    isSortable: true,
    render: (sumBaseCost) => <div>{Number(sumBaseCost).toLocaleString()}</div>,
  },
  {
    title: 'جمع سهم کافه',
    dataIndex: 'sumToBePaidToCafePrice',
    name: 'sumToBePaidToCafePrice',
    isSortable: true,
    render: (sumRseeStockAmount) => <div>{Number(sumRseeStockAmount).toLocaleString()}</div>,
  },
  {
    title: 'جمع سهم آرسی',
    dataIndex: 'sumRseeStockAmount',
    name: 'sumRseeStockAmount',
    isSortable: true,
    render: (sumRseeStockAmount) => <div>{Number(sumRseeStockAmount).toLocaleString()}</div>,
  },
  {
    title: 'حد تسویه',
    dataIndex: 'minCheckout',
    name: 'minCheckout',
    isSortable: true,
    render: (minCheckout) => <div>{Number(minCheckout).toLocaleString()}</div>,
  },
  {
    title: 'مبلغ تسویه',
    dataIndex: 'sumToBePaidToCafePrice',
    name: 'sumToBePaidToCafePrice',
    isSortable: true,
    render: (sumToBePaidToCafePrice) => <div>{Number(sumToBePaidToCafePrice).toLocaleString()}</div>,
    // render: (sumToBePaidToCafePrice) => (
    //   <div className={`direction-ltr ${sumToBePaidToCafePrice < 0 && 'red-color'}`}>{Number(sumToBePaidToCafePrice).toLocaleString()}</div>),
  },
  {
    title: 'تعداد رزروها',
    dataIndex: 'reservesCount',
    name: 'reservesCount',
    isSortable: true,
  },
  {
    title: 'عملیات',
    action: (item, action) => (
      <>
        <span
          onClick={e => {
            e.preventDefault();
            item.hasRelatedReserves && action.checkoutReservationDetails(item);
          }}
          href="#"
          className={`text-success checkout-field ${!item.hasRelatedReserves && 'disable-field'}`}
        >
          {locales('labels.relatedReservation')}
        </span>
        <span style={{
          borderLeft: '2px solid green',
          padding: '2px',
          marginLeft: '3px',
        }}/>
        <span
          onClick={e => {
            e.preventDefault();
            if (item.canCheckout) {
              action.checkoutSpecificRecord(item);
            }
          }}
          href="#"
          className={`text-success checkout-field ${!item.canCheckout && 'disable-field'}`}
        >
          {locales('labels.checkout')}
        </span>
      </>
    ),
  },
];
